import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {Button, FontAwesomeIcon} from "~/components";
import {InputField, TextAreaField, NumberField, SelectField} from "~/components/Forms";

/**
 * Form động cho 1 tác vụ AI — DÙNG HỆ THỐNG FORM CHUẨN của dự án:
 * react-hook-form (Controller + errors) + field dùng chung (InputField/TextAreaField/
 * NumberField) trong scope `.form`. KHÔNG dùng antd Input/InputNumber trực tiếp
 * (xem docs/features/frontend-data-standards.md — mọi form phải đồng nhất).
 *
 * Field dựng theo task.inputs trả từ BE: {name, label, type(text|textarea|number),
 * required, placeholder, default}. Đổi tác vụ (task.key) → reset lại giá trị.
 */
function AiTaskForm({task, loading, disabled, onSubmit, prefill}) {

	const inputs = task.inputs || [];
	// prefill (từ navigate state, vd nút "Gợi ý bài viết" ở /trends) ưu tiên hơn default.
	const defaultValues = Object.fromEntries(inputs.map((f) => [f.name, prefill?.[f.name] ?? f.default ?? '']));

	const {control, handleSubmit, reset, formState: {errors}} = useForm({defaultValues});

	// Reset khi chuyển sang tác vụ khác (bộ input khác nhau).
	useEffect(() => {
		reset(defaultValues);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [task.key]);

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{inputs.map((f) => (
				<Controller
					key={f.name}
					control={control}
					name={f.name}
					rules={{required: f.required ? `Vui lòng nhập: ${f.label}` : false}}
					render={({field}) => {
						const common = {label: f.label, placeholder: f.placeholder, errors, ...field};

						if (f.type === 'textarea') {
							return <TextAreaField rows={5} {...common} />;
						}
						if (f.type === 'number') {
							return <NumberField min={1} max={20} {...common} />;
						}
						if (f.type === 'select') {
							return <SelectField options={f.options || []} {...common} />;
						}
						return <InputField {...common} />;
					}}
				/>
			))}

			<Button
				primary
				type="submit"
				loading={loading}
				disabled={disabled}
				leftIcon={<FontAwesomeIcon icon="fa-light fa-wand-magic-sparkles" />}
			>
				Tạo nội dung
			</Button>
		</form>
	);
}

export default AiTaskForm;
